import {
  HomeOutlined,
  ApiOutlined,
  UserOutlined,
  PicLeftOutlined,
} from "@ant-design/icons";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import ROUTES from "shared/routes";
import styles from "./index.module.scss";

export const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const activeTab = location?.pathname?.includes("/profile")
    ? "profile"
    : location?.pathname?.includes("/help")
    ? "help"
    : location?.pathname?.includes("/tasks")
    ? "tasks"
    : "main";

  return (
    <footer className={styles.footer}>
      <Button
        onClick={() => navigate(ROUTES.MAIN)}
        type="link"
        className={`${styles.link} ${
          activeTab === "main" ? styles.active : ""
        }`}
      >
        <Flex align="center" justify="space-between" vertical>
          <HomeOutlined />
          {t("nav.main")}
        </Flex>
      </Button>
      <Button
        onClick={() => navigate(ROUTES.TASKS)}
        type="link"
        className={`${styles.link} ${
          activeTab === "tasks" ? styles.active : ""
        }`}
      >
        <Flex align="center" justify="space-between" vertical>
          <PicLeftOutlined />
          {t("nav.tasks")}
        </Flex>
      </Button>
      <Button
        onClick={() => navigate(ROUTES.PROFILE)}
        type="link"
        className={`${styles.link} ${
          activeTab === "profile" ? styles.active : ""
        }`}
      >
        <Flex align="center" justify="space-between" vertical>
          <UserOutlined />
          {t("nav.profile")}
        </Flex>
      </Button>
      <Button
        onClick={() => navigate(ROUTES.HELP)}
        type="link"
        className={`${styles.link} ${
          activeTab === "help" ? styles.active : ""
        }`}
      >
        <Flex align="center" justify="space-between" vertical>
          <ApiOutlined />
          {t("nav.help")}
        </Flex>
      </Button>
    </footer>
  );
};
